import PropTypes from 'prop-types';
import { Card } from 'antd';
import cx from 'classnames';
import Icon from '@ant-design/icons';
import { AccountIcon } from '@ring-icons';
import virtualSecurityGuard from '$src/assets/icons/virtual_security_guard.svg';

export default function UnboardedLocation({ location, setActiveLocation, activeLocation, disabled }) {
  return (
    <Card
      key={location.locationId}
      onClick={() => !disabled && setActiveLocation(location)}
      hoverable={location.hasEntitlements}
      className={cx('location', {
        'location-card-active': activeLocation.locationId === location.locationId,
        'location-card-disabled': disabled,
      })}
    >
      <div className="location-header">
        <Icon component={virtualSecurityGuard} />
        <p>{location.locationName}</p>
      </div>
      <p>Get your Service up and running in just a few steps.</p>

      {!location.isOwner && (
        <p className="location-shared--message" data-testid="location-shared">
          Shared locations must be enrolled by the owner.
        </p>
      )}
      {!location.hasEntitlements && (
        <p className="location-unsubscribed--message" data-testid="location-not-entitlements">
          This location is not eligible.
        </p>
      )}
    </Card>
  );
}

UnboardedLocation.propTypes = {
  location: PropTypes.object.isRequired,
  setActiveLocation: PropTypes.func.isRequired,
  activeLocation: PropTypes.object,
  disabled: PropTypes.bool,
};
